import React, {useEffect, useMemo, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'

import Globalsetting, {emailOption} from './Modal/Globalsetting'
import Emailtosms from './Modal/EmailTosms'
import './EmailTosms.scss'
import {useDispatch, useSelector} from 'react-redux'
import {
  GetListOfEmailtoSms,
  deleteEmailToSms,
  getEmailToSms,
} from './EmailToSmsSlice/EmailToSmsSlice'
import {
  getAllUserDetails,
  getDefaultRegion,
  getIsDefaultRegion,
} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import InsertNewData from '../../../Components/InsertNewData'
import { constantsRegion } from '../../../Utils/_helpers'

const EmailToSms = () => {
  const dispatch = useDispatch()
  const emaitosmslist = useSelector(getEmailToSms)
  const userValues = useSelector(getAllUserDetails)
  const userRegion = useSelector(getDefaultRegion)
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [data, setData] = useState()
  const [checkList, setCheckList] = useState<any>([])

  const [openPopup, setOpenPopup] = useState(false)
  const [globalSettingPopup, setGlobalSettingsPopup] = useState(false)
  const [editData, setEditData] = useState({})
  useEffect(() => {
    if (confirm == true) {
      dispatch(deleteEmailToSms(deleteIds))
      setCheckList([])
      setConfirm(false)
    }
  }, [confirm])
  const popup = useMemo(
    () => <Emailtosms show={openPopup} handleClose={() => setOpenPopup(false)} data={editData} />,
    [openPopup]
  )
  const popup2 = useMemo(
    () => (
      <Globalsetting show={globalSettingPopup} handleClose={() => setGlobalSettingsPopup(false)} />
    ),
    [globalSettingPopup]
  )

  useEffect(() => {
    dispatch(GetListOfEmailtoSms())
  }, [])

  const handleDelete = () => {}

  const DeleteConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete this  email? '}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const emailRegion = isDefaultRegion ? 'sms' : userRegion
  const numberRegion = isDefaultRegion ? '+61' : constantsRegion.CountryCodeMap[userRegion.toUpperCase()]


  return (
    <>
      {DeleteConfirmation}
      {popup}
      {popup2}
      <div className='card p-7 pb-lg-4 p-lg-10 emailtosms'>
        <h1>Email To SMS Page</h1>

        <div className='row'>
          <div className='col-xl-5'>
            <div className='insrtuction mt-7'>
              <div className='ins_box'>
                <div className='ins_box_title'>
                  <strong>INSTRUCTIONS</strong>
                </div>
                <div className='ins_box_datail'>
                  <ul>
                    <li>
                      <span>1</span>

                      <div>
                        Enter your contact's mobile number followed by @{`${emailRegion}`}
                        .cellcast.com
                      </div>
                    </li>
                    <li>
                      <span>2</span>
                      <div>
                        Enter the message in the subject or body of the email
                        <p>TIP: Use keywords like "start" and "end" to outline the message body</p>
                      </div>
                    </li>
                    <li>
                      <span>3</span>
                      <div>
                        Message is sent from your Email Inbox, you'll receive all replies back to
                        your Cellcast inbox
                      </div>
                    </li>
                  </ul>
                  <p className='m-0'>
                    Still have questions?
                    <a href='https://support.cellcast.com.au/' target='_blank'>
                      {' '}
                      Contact us at support@cellcast.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className='col-xl-4'>
            <div className='emailsms_box_outer ps-0 ps-xl-15 mt-7 mt-lg-10'>
              <div className='process'>
                <span className='process_line'></span>
                <span className='process_name'>
                  <img src={toAbsoluteUrl('/media/misc/email.svg')} className='me-2' alt='img' />
                  Email
                </span>
              </div>
              <div className='emailsms_box'>
                <form>
                  <div className='form-group'>
                    <label>To:</label>
                    <input
                      type='email'
                      className='form-control'
                      placeholder={`<recipientnumber>@${emailRegion}.cellcast.com`}
                    />
                  </div>
                  <div className='form-group'>
                    <label>Cc:</label>
                    <input type='email' className='form-control' />
                  </div>
                  <div className='form-group'>
                    <label>Subject:</label>
                    <input type='text' className='form-control' />
                  </div>
                  <p>
                    Dear John, Thank you for purchasing with us. Your order will be delivered 10th of December. If you have any questions, give us a call on
                    {numberRegion} 489 382 382 or reply back to use here.
                  </p>
                </form>
              </div>
              <div className='process'>
                <span className='process_line'></span>
                <span className='process_name'>
                  <img src={toAbsoluteUrl('/media/misc/comment.svg')} className='me-2' alt='img' />
                  SMS
                </span>
              </div>
            </div>
          </div>
          <div className='col-xl-3'>
            <div
              className='mobile-bg-wrapper grey-bg new_mobile'
              style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
              }}
            >
              <div className='mobile-inner'>
                <div className='mobile-head'>
                  <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                    <KTSVG
                      className='svg-icon-8'
                      path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                    />{' '}
                    Your business
                  </strong>
                </div>
                <div className='mobile-body'>
                  <div className='message-box'>
                    <div className='message'>
                    Dear John, Thank you for purchasing with us. Your order will be delivered 10th of December. If you have any questions, give us a call on
                    {numberRegion} 489 382 382 or reply back to use here.
                    </div>
                  </div>
                  <div className='send-msg'>
                    <input type='text' />
                    <a
                      href='#'
                      className='send_btn'
                      style={{backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.png')})`}}
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='row mt-8'>
        <div className='col-lg-8'>
          <div className='card pt-8'>
            <div className='card-header card-header-stretch border-bottom-0 align-items-start'>
              <div className='mb-5'>
                <h1>Whitelisted</h1>
                <span className='text-muted'>Ordered by most recent</span>
              </div>
              <button
                type='button'
                className='btn btn-primary btn-blue'
                onClick={() => {
                  // navigate('/contacts/segments')
                  setEditData({})
                  setOpenPopup(true)
                }}
              >
                Create new
              </button>
            </div>
            {emaitosmslist?.length > 0 ? (
              <div className='card-body pt-2'>
                <div className='tab-content'>
                  <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold text-muted text-uppercase'>
                          <th>email</th>
                          <th>domain</th>
                          <th>sender id</th>
                          <th>region</th>
                          <th>action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {emaitosmslist?.map((key: any, index: any) => (
                          <tr key={index}>
                            {key?.email?.length > 0 ? (
                              <td>
                                {key?.email?.[0]} &nbsp;
                                <span>
                                  {`${key?.email.length > 1 ? `+${key?.email.length - 1}` : ''}`}{' '}
                                </span>
                              </td>
                            ) : (
                              <td>-</td>
                            )}
                            <td>{key?.wildCardDomain} </td>
                            <td>{key?.sender}</td>
                            <td>{key?.region}</td>
                            <td>
                              <div className='row'>
                                <a
                                  onClick={() => {
                                    setEditData(key)
                                    setOpenPopup(true)
                                  }}
                                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                >
                                  <span className='svg-icon svg-icon-3'>
                                    <i className='bi bi-pencil-fill'> </i>
                                  </span>
                                </a>
                                <a
                                  onClick={() => {
                                    setOpen(true)
                                    setDeleteIds(key?._id)
                                  }}
                                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                >
                                  <span className='svg-icon svg-icon-3'>
                                    <span className='svg-icon svg-icon-3'>
                                      <svg
                                        width='24'
                                        height='24'
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                        className='mh-50px'
                                      >
                                        <path
                                          d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                                          fill='currentColor'
                                        >
                                          {' '}
                                        </path>
                                        <path
                                          opacity='0.5'
                                          d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                                          fill='currentColor'
                                        >
                                          {' '}
                                        </path>
                                        <path
                                          opacity='0.5'
                                          d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                                          fill='currentColor'
                                        >
                                          {' '}
                                        </path>
                                      </svg>
                                    </span>
                                  </span>
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <InsertNewData
                message={{
                  title: `You don't have any white listed addresses (yet!)`,
                  subtitle: `Ready to add one?`,
                }}
                buttonName={{
                  name: 'Create new',
                  link: '',
                  popup: true,
                  buttonFun: () => {
                    // navigate('/contacts/segments')
                    setEditData({})
                    setOpenPopup(true)
                  },
                }}
              />
            )}
          </div>
        </div>
        <div className='col-lg-4'>
          <div className='card p-10'>
            <h1>Global Settings</h1>
            <span className='text-muted'>Email content and keywords</span>

            <ul className='global-setting mt-7'>
              <li>
                <aside>
                  <h5>Content settings</h5>
                  <span className='text-muted'>
                    {
                      emailOption?.find(
                        (key: any) => key?.value === userValues?.emailSmsSubjectSetting?.toString()
                      )?.label
                    }
                  </span>
                </aside>
                <a
                  onClick={() => setGlobalSettingsPopup(true)}
                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                >
                  <span className='svg-icon svg-icon-3'>
                    <i className='bi bi-pencil-fill'></i>
                  </span>
                </a>
              </li>
              <li>
                <aside>
                  <h5>SMS start tags</h5>
                  {userValues?.smsStartTag?.length > 0 ? (
                    userValues?.smsStartTag?.map((key: any, i: number) => (
                      <span key={i}>{`${key}`}</span>
                    ))
                  ) : (
                    <span className='text-muted'>No start tags have been selected</span>
                  )}
                </aside>
                <a
                  onClick={() => setGlobalSettingsPopup(true)}
                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                >
                  <span className='svg-icon svg-icon-3'>
                    <i className='bi bi-pencil-fill'></i>
                  </span>
                </a>
              </li>
              <li>
                <aside>
                  <h5>SMS end tags</h5>
                  {userValues?.smsEndTag?.length > 0 ? (
                    userValues?.smsEndTag?.map((key: any, i: number) => (
                      <span key={i}>{`${key}`}</span>
                    ))
                  ) : (
                    <span className='text-muted'>No end tags have been selected</span>
                  )}
                </aside>
                <a
                  onClick={() => setGlobalSettingsPopup(true)}
                  className=' col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                >
                  <span className='svg-icon svg-icon-3'>
                    <i className='bi bi-pencil-fill'></i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmailToSms
